import { useApi } from '../../../httpClient/useAuthClient';
import { useState } from 'react';
import { AUTH_ENTRYPOINT } from '../../../routing/api-routes';
import axios from 'axios';
import { ApiSchema } from '../../../types/openApiHelpers';

export type FornitoreDTO = ApiSchema<'FornitoreDTO'>;

const getFornitoreRequestRoute = () => AUTH_ENTRYPOINT + '/fornitori/request';
export const useGetFornitori = () => {
    const [fornitori, setFornitori] = useState<FornitoreDTO[]>([]);
    const { call: get } = useApi('get_lista_fornitori');

    const getFornitori = () =>
        get().then((response) => {
            setFornitori(response.data);
        });

    return { getFornitori, fornitori, setFornitori };
};

export const useGetFornitoriRequest = () => {
    const [fornitoriRequest, setFornitoriRequest] = useState<
        FornitoreDTO | undefined
    >();

    const getFornitoriRequest = () =>
        axios.get(getFornitoreRequestRoute()).then((response) => {
            setFornitoriRequest(response.data);
            return response;
        });

    return { getFornitoriRequest, fornitoriRequest };
};
